export default __webpack_public_path__ + "static/media/ly.8af20e0c.svg";